import * as React from "react";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={className}
      style={{
        textAlign: "center",
        padding: "var(--space-6, 24px) var(--space-4, 16px)",
        background: "var(--bg-surface, #fafafa)",
        border: "1px solid var(--border-default)",
        borderRadius: "var(--radius-lg, 12px)",
      }}
    >
      {icon && (
        <div style={{ fontSize: 40, marginBottom: "var(--space-3, 12px)", lineHeight: 1 }}>
          {icon}
        </div>
      )}
      <h4
        style={{
          fontFamily: "var(--font-sans)",
          fontSize: 15,
          fontWeight: "var(--font-weight-semibold, 600)",
          color: "var(--text-primary)",
          margin: "0 0 var(--space-2, 8px)",
        }}
      >
        {title}
      </h4>
      {description && (
        <p
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: 13,
            color: "var(--text-muted)",
            margin: "0 0 var(--space-4, 16px)",
            lineHeight: 1.5,
          }}
        >
          {description}
        </p>
      )}
      {action && action}
    </div>
  );
}
